// extracted by mini-css-extract-plugin
export var filterHeader = "research-module--filterHeader--4yKr+";
export var filterRows = "research-module--filterRows--xhsPU";
export var layoutButton = "research-module--layoutButton--tDw9q";
export var layoutLabel = "research-module--layoutLabel--+JbW2";
export var layoutSwitch = "research-module--layoutSwitch--XXbCo";
export var publicationGrid = "research-module--publicationGrid--lq3LC";